import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const PRESETS = [3, 7, 14];

interface OfferExpirationFieldProps {
  value: number; // days
  onChange: (days: number) => void;
}

/** Preset (3/7/14 days) + custom offer-expiration picker. */
export function OfferExpirationField({ value, onChange }: OfferExpirationFieldProps) {
  const isPreset = PRESETS.includes(value);
  return (
    <div className="flex flex-wrap items-center gap-2">
      {PRESETS.map((days) => (
        <Button
          key={days}
          type="button"
          variant={value === days ? "default" : "outline"}
          className="h-11"
          onClick={() => onChange(days)}
        >
          {days} days
        </Button>
      ))}
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant={!isPreset ? "default" : "outline"}
          className="h-11"
          onClick={() => onChange(!isPreset ? value : 30)}
        >
          Custom
        </Button>
        {!isPreset && (
          <Input
            type="number"
            inputMode="numeric"
            min={1}
            max={365}
            className="h-11 w-20"
            value={value}
            onChange={(e) => onChange(Math.max(1, Math.min(365, Number(e.target.value) || 1)))}
            aria-label="Custom expiration in days"
          />
        )}
      </div>
    </div>
  );
}
